import { useMemo } from "react";

const DOW = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];

function build7DayBuckets() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const days = [];
  for (let i = 0; i < 7; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    days.push({
      iso: d.toISOString().slice(0, 10),
      dow: DOW[d.getDay()],
      dayNum: d.getDate(),
      pickups: 0,
      deliveries: 0,
    });
  }
  return days;
}

/**
 * Hook that aggregates pickup/delivery counts per day for the next 7 days
 * starting from today. Returns { days, total, max }.
 */
export function useWeeklyChartData(operator) {
  return useMemo(() => {
    const days = build7DayBuckets();
    const idxByIso = Object.fromEntries(days.map((d, i) => [d.iso, i]));

    const bump = (iso, kind) => {
      const i = idxByIso[iso];
      if (i !== undefined) days[i][kind]++;
    };

    (operator.quotes || []).forEach(q => {
      if (q.pickup_date) bump(q.pickup_date, "pickups");
      if (q.delivery_date && q.delivery_date !== q.pickup_date) bump(q.delivery_date, "deliveries");
    });
    (operator.inventories || []).forEach(inv => {
      if (inv.pickup_date) bump(inv.pickup_date, "pickups");
      if (inv.delivery_date && inv.delivery_date !== inv.pickup_date) bump(inv.delivery_date, "deliveries");
    });

    const total = days.reduce((s, d) => s + d.pickups + d.deliveries, 0);
    const max = Math.max(1, ...days.map(d => d.pickups + d.deliveries));
    return { days, total, max };
  }, [operator]);
}
